export class UserDM {
  constructor({
    email = "",
    first_name = "",
    last_name = "",
    phone_number = "",
  }) {
    this.email = email;
    this.first_name = first_name;
    this.last_name = last_name;
    this.phone_number = phone_number;
  }

  toJson() {
    return {
      email: this.email,
      first_name: this.first_name,
      last_name: this.last_name,
      phone_number: this.phone_number,
    };
  }

  static fromJson(json) {
    return new UserDM({
      email: json["email"],
      first_name: json["first_name"],
      last_name: json["last_name"],
      phone_number: json["phone_number"],
    });
  }
}
